import { WellnessMetadata } from "./wellness-metadata";
import { AnthropometricMetadata } from "./anthropometric-metadata";
import { Exercise } from "./exercise";
import { ScoreMetadata } from "./score-metadata";
import { Circuit } from "./circuit";

export enum MetadataType {
  EXERCISE = "Exercise",
  WELLNESS = "Wellness",
  ANTHROPOMETRIC = "Anthropometric",
  ONE_REP_MAX = "OneRepMax",
  SCORE = "Score",
  CIRCUIT = "Circuit",
  LOAD_VELOCITY_PROFILE = "LoadVelocityProfile",
}

export const MetadataTypeValues = Object.values(MetadataType);

export interface MetadataExercise {
  id: string;
  type: MetadataType.EXERCISE;
  typeLabel: string;
  metadata: Exercise;
}
export interface MetadataAnthropometric {
  id: string;
  type: MetadataType.ANTHROPOMETRIC;
  typeLabel: string;
  metadata: AnthropometricMetadata;
}
export interface MetadataWellness {
  id: string;
  type: MetadataType.WELLNESS;
  typeLabel: string;
  metadata: WellnessMetadata;
}
export interface MetadataScore {
  id: string;
  type: MetadataType.SCORE;
  typeLabel: string;
  metadata: ScoreMetadata;
}
export interface MetadataCircuit {
  id: string;
  type: MetadataType.CIRCUIT;
  typeLabel: string;
  metadata: Circuit;
}

export type Metadata = MetadataExercise | MetadataAnthropometric | MetadataWellness | MetadataScore | MetadataCircuit;

export interface MetadataItem {
  id: string;
  field: string | null;
  type: Omit<MetadataType, MetadataType.ONE_REP_MAX | MetadataType.SCORE | MetadataType.LOAD_VELOCITY_PROFILE>;
}
